import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

const HasCallRoute = ({ children, hasCall }) => {
    const location = useLocation();
    
    if (hasCall === true) {
        return children;
    } else {
        return (
            <Navigate
                to={{
                    pathname: '/create-call-request',
                    state: { from: location },
                }}
                replace
            />
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return { hasCall: !!state.call.call };
};

export default connect(mapStateToProps, null)(HasCallRoute);
